// extracted by mini-css-extract-plugin
module.exports = {"jds-CardTime":"cardTime_jds-CardTime__5StAm","jds-CardTime--isPush":"cardTime_jds-CardTime--isPush__yMi7n"};